import { Component, Input, OnInit } from '@angular/core';
import { isEmpty, get } from 'lodash';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-downloader-loader',
  templateUrl: './downloader-loader.component.html',
  styleUrls: ['./downloader-loader.component.scss']
})
export class DownloaderLoaderComponent implements OnInit {

  constructor() { }
  @Input() body: any;
  @Input() isLoading= false;
  @Input() timerData :any;
  @Input() isShowTimerData = true;
  @Input() backgroundMode = false;
  display = "00:00";
  loader:any
  intervalFunction;
  imageUrl = environment.whitelabelLogoPath
  ngOnInit(): void {
    if (!this.backgroundMode) {
      this.enableTimer(get(this.timerData, 'downloadTimer', 5) * 60, this.timerData);
    }
    let data  =JSON.parse(localStorage.getItem('whitelabelResData')) ;
    if(!data) {
      this.loader = "/assets/gif/loader.gif";
    } else {
      this.loader = `${this.imageUrl}/${data?.gifLoader}`
    }
  }

  switchToBackgroundMode(message: string): void {
    if (this.intervalFunction) {
      clearInterval(this.intervalFunction);
      this.intervalFunction = null;
    }
    this.backgroundMode = true;
    this.body = message;
  }

  enableTimer(duration, timerData) {
    var timer = duration, minutes, seconds;
    const self = this;
    this.intervalFunction = setInterval(function () {
        minutes = parseInt(`${timer / 60}`, 10);
        seconds = parseInt(`${timer % 60}`, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        this.display = minutes + ":" + seconds;
      const val = timerData?.totalNoOfRows?.toLocaleString() || ''
      const timerDataElement = document.getElementById('timerData');
       let dynamicCondition = self.isShowTimerData ? timerDataElement : timerDataElement && self.isShowTimerData;
      if (dynamicCondition) {
        timerDataElement.classList.add("d-block");
        timerDataElement.innerHTML = `Downloading records, approximate download time <span class="p-1 mdi mdi-timer-sand mdi-spin font-weight-bold"> ${this.display}</span>`;
      }
        
        if (--timer < 0) {
            timer = duration;
        }
    }, 1000);
  }
  ngOnDestroy() {
    clearInterval(this.intervalFunction);
  }
}
